import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteReleaseDocumentMutation, getReleaseQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteReleaseDocument = (releaseId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteReleaseDocumentAction, { loading }] = useMutation(
        deleteReleaseDocumentMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getReleaseQuery,
                    variables: {
                        where: { id: releaseId },
                    },
                },
            ],
        },
    );

    const { deleteReleaseDocumentPending: deleteReleaseDocumentPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteReleaseDocument = async (id) => {
        try {
            await deleteReleaseDocumentAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: `${t("releases.entity")} ${t("labels.document")}` },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: {
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteReleaseDocumentPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: `${t("releases.entity")} ${t("labels.document")}` },
                    ),
                    { toastId: `${deleteReleaseDocumentPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteReleaseDocument };
};

export default useDeleteReleaseDocument;
